export default "__VITE_ASSET__BfND0RfO__"